export const GENERAL_BRANCH = 'general';
